<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_hollywoodsmile_two')" />

        <HollywoodSmileLongevity />
    </div>
</template>

<script>

import HollywoodSmileLongevity from '../blog-details/HollywoodSmileLongevity.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
        PageBanner,
        HollywoodSmileLongevity,
    }
}
</script>